<script setup lang="ts">
import VButton from '@components/buttons/VButton/VButton.vue';

function onClick(): void {
  window.location.reload();
}
</script>

<template>
  <div v-data-qa-auto-id="'ErrorServiceUnavailable'"
    class="
      m-auto
      flex
      h-full
      max-w-sm
      flex-col
      items-center
      justify-center
      text-center"
  >
    <i class="pi pi-cog mb-6 !text-8xl font-extrabold" />
    <div class="mb-4 text-xl font-medium">
      Server is temporarily unavailable
    </div>
    <div class="mb-3 leading-7">
      We are currently undergoing scheduled system maintenance.
      Please try again soon. We apologise for the inconvenience.
    </div>
    <VButton
      label="Reload"
      class="w-full max-w-40"
      @click="onClick"
    />
  </div>
</template>
